import React, { useEffect } from 'react'
import { Result } from 'antd';

import axios from './apiClient'

export default function Unauthorized() {

  const checkData = async ()=> {
    const res = await axios.get(`/bet/getBettingByTV`);
    if(res.code == 200) {
      window.location.hash = "/"
    }
  }

  useEffect(()=>{
    checkData()
  },[])
  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you are not authorized to access this page."
    />
  )
}
